import './App.css'
import FruitsPage from './pages/FruitsPage'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <FruitsPage />
      </header>
    </div>
  )
}

export default App
